import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Root } from "./root";
import MainContextProvider from "./context";
import "antd/dist/antd.min.css";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <MainContextProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Root />
        </Router>
      </QueryClientProvider>
    </MainContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
